import React, { useMemo } from 'react';
import { USMap } from '../map/index';
import { NonIdealState } from '@blueprintjs/core';
import { formatDataAsMap } from '../map/helpers';
import { selectDilDefinitionByName } from 'srs-middleware';
import { NO_DATA_MESSAGE } from 'widgets/chartUtils';

/**
 * ChartWrapper for the US Map.
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @param selectedDefinitionName
 * @returns {*}
 * @constructor
 */
export function USMapWrapper({ widgetConfiguration, dimensions, data, selectedDefinitionName, noDataMessage=NO_DATA_MESSAGE }) {
	// get the actual definition
	const selectedDefinition = useMemo(() => {
		return selectDilDefinitionByName(selectedDefinitionName);
	}, [selectedDefinitionName]);

	const convertedData = useMemo(() => {
		if (!data || !selectedDefinition || !data[selectedDefinition.systemDefinitionId]) return;

		const returnValue = Object.entries(data[selectedDefinition.systemDefinitionId]).map(entry => {
			return {
				key: entry[0],
				...entry[1],
				entries: entry[1].entries.map(e => {
					return {
						...e,
						key: e.key,
					};
				}),
			};
		});

		return formatDataAsMap(returnValue[0]);
	}, [data, selectedDefinition]);

	// If the state is not ideal (the data is null or empty) render the nonIdealState message
	return convertedData ? (
		<USMap data={convertedData} dimensions={dimensions} showLegend={widgetConfiguration?.showLegend} />
	) : (
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description={noDataMessage}
		/>
	);
}
